import { Container, Flex, SkeletonText } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { GeneralMarkdown } from '@/components/ui/shared/markdowns/GeneralMarkdown/GeneralMarkdown';
import { librarianResourcesQueryOptions } from '@/queries/upgrade/librarianResources';

export const LibrariansContentFallback: FC = () => {
  return (
    <Section py={{ base: 5, lg: 12 }}>
      <Container>
        <Flex flexDir="column">
          <SkeletonText noOfLines={4} spacing={4} p={6} />
          <SkeletonText noOfLines={4} spacing={4} p={6} />
          <SkeletonText noOfLines={4} spacing={4} p={6} />
          <SkeletonText noOfLines={4} spacing={4} p={6} />
        </Flex>
      </Container>
    </Section>
  );
};

export const LibrariansContent: FC = () => {
  const { data, error } = useQuery(librarianResourcesQueryOptions());

  if (error) throw error;

  if (!data) {
    return <LibrariansContentFallback />;
  }

  return (
    <Section pt={{ base: 5, lg: 12 }} pb={{ base: 16, lg: 24 }}>
      <Container>
        <GeneralMarkdown source={data[0].content} />
      </Container>
    </Section>
  );
};
